'use strict';

function addTrackingPixel (label, status) {
  const ea = label || 'tag';
  const ec = status ? 'Allowing' : 'Blocking';
  const img = document.createElement('img');
  const endpoint = '/en/gamp/collect';

  img.setAttribute('style', 'display:none;');
  img.src = endpoint + '?category=' + ec + '&action=' + ea;
  document.body.appendChild(img);
}

module.exports = addTrackingPixel;
